import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Textarea } from "@/components/ui/textarea";
import { Search } from "lucide-react";
interface ChatInputProps {
  isLoading: boolean;
  isGibletPage: boolean;
  onSendMessage: (message: string) => void;
  onInputFocus: () => void;
}
const ChatInput = ({
  isLoading,
  isGibletPage,
  onSendMessage,
  onInputFocus
}: ChatInputProps) => {
  const [input, setInput] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const isCurtChannel = location.pathname === "/curt-channel";
  const curtChannelPrompt = "CfS: Develop an updated, AI-consumable and blockchain-protected version of the Owners Modularization Blueprint (OMB) tailored for 2025 construction realities. The goal is to integrate industry best practices, smart contract governance, and digital twin-informed execution planning to improve capital project performance using the iSPAI model.";
  const handleSend = () => {
    if (input.trim()) {
      if (isCurtChannel) {
        navigate("/demo-call-for-solutions/bounty");
      } else {
        onSendMessage(input);
        setInput("");
      }
    }
    setIsExpanded(false);
  };
  const handleFocus = () => {
    onInputFocus();
    setIsExpanded(true);

    // Set the canned prompt for CURT channel
    if (isCurtChannel && (!input || input.trim() === "")) {
      console.log("Setting CURT channel prompt");
      setInput(curtChannelPrompt);

      // Adjust height after setting content with a slight delay to ensure DOM update
      setTimeout(() => {
        adjustTextareaHeight();
      }, 50);
    }
  };
  const handleBlur = (e: React.FocusEvent) => {
    // Check if the related target is part of the expanded area
    const expandedArea = document.querySelector('.expanded-chat-area');
    if (!expandedArea?.contains(e.relatedTarget as Node) && !input.trim()) {
      setIsExpanded(false);
    }
  };
  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      console.log("Adjusted textarea height:", textareaRef.current.style.height);
    }
  };
  const getPlaceholderText = () => {
    if (location.pathname === "/curt-channel") {
      return "Ask Giblet Construct";
    }
    if (location.pathname === "/chevron-channel") {
      return "Ask Giblet Chevron";
    }
    if (location.pathname === "/usa-channel") {
      return "Ask Giblet Fed";
    }
    return "Ask Giblet";
  };
  useEffect(() => {
    if (input && isExpanded) {
      adjustTextareaHeight();
    }
  }, [input, isExpanded]);

  // Force populate the input when the component loads on the CURT channel
  useEffect(() => {
    if (isCurtChannel && isExpanded && !input.trim()) {
      setInput(curtChannelPrompt);
    }
  }, [isExpanded, isCurtChannel]);
  return <div className="relative">
      <div className="flex flex-col items-center space-y-2">
        <div className="relative w-[432px]">
          <div className="relative">
            
            
          </div>
        </div>
      </div>
      
      {isExpanded && <div className="expanded-chat-area absolute top-full left-0 mt-2 w-[700px] z-10 bg-white border border-gray-200 rounded-md shadow-lg">
          <Textarea ref={textareaRef} value={input} onChange={e => {
        setInput(e.target.value);
        adjustTextareaHeight();
      }} className="w-full p-4 resize-none border-none" onKeyDown={e => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          handleSend();
        }
      }} disabled={isLoading} autoFocus />
          <div className="flex justify-end p-2 bg-gray-50 rounded-b-md">
            <button onClick={handleSend} className="px-4 py-1 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors" disabled={isLoading}>
              Send
            </button>
          </div>
        </div>}
      
      {isLoading && <div className="absolute right-48 top-3">
          <div className="animate-spin h-5 w-5 border-2 border-gray-500 border-t-transparent rounded-full"></div>
        </div>}
    </div>;
};
export default ChatInput;